"use strict";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "admin-lte/dist/css/AdminLTE.min.css";
import "admin-lte/dist/css/skins/skin-blue.min.css";
import "../resources/static/dist/css/qcss.spacing.css"
import "../resources/static/dist/css/overrides.css"

import "jquery"
import "popper.js/dist/popper.js";
import "bootstrap/dist/js/bootstrap.js";
import "admin-lte/dist/js/adminlte.js";

import React, { Component } from "react";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from '@fortawesome/free-brands-svg-icons'

import {
    faCheckCircle, faBan, faExclamationTriangle, faInfoCircle, faQuestionCircle, faChevronCircleRight,
    faFilm, faLink, faUnlink, faTimesCircle, faCalendar, faFileVideo, faFileImage, faStream, faDownload,
    faStar, faRedo, faSignOutAlt, faFilter, faFolderOpen, faPlus, faMinus, faBug, faEllipsisH, faCopy, faCogs
}
    from "@fortawesome/free-solid-svg-icons";

library.add(fab, faCheckCircle, faBan, faExclamationTriangle, faInfoCircle, faQuestionCircle, faChevronCircleRight,
            faFilm, faLink, faUnlink, faTimesCircle, faCalendar, faFileVideo, faFileImage, faStream, faDownload,
            faStar, faRedo, faSignOutAlt, faFilter, faFolderOpen, faPlus, faMinus, faBug, faEllipsisH, faCopy, faCogs);

import Routes from "./component/Routes";
import Wrapper from "./component/Template/Wrapper";
import Header from "./component/Template/Header";
import ContentWrapper from "./component/Template/ContentWrapper";
import ContentContainer from "./component/Template/ContentContainer";

import {routes} from "./const";
import SummaryReport from "./component/EnrichedVideo/Widget/SummaryReport";
import {FilterConsumer, FilterProvider} from "./context/FilterContext";
import {Provider as AlertProvider} from "react-alert";
import Alert from "./component/Widget/Alert";

class App extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <AlertProvider template={Alert}>
            <FilterProvider>
                <Wrapper>
                    <Header routes={routes}/>
                    <ContentWrapper>
                        <ContentContainer>
                            <FilterConsumer>
                                {(context) => <SummaryReport filterContext={context} /> }
                            </FilterConsumer>
                            {routes.map((route, i) => (
                                <FilterConsumer key={i}>
                                    {(context) => <Routes key={i} props={{filterContext:context}} {...route} /> }
                                </FilterConsumer>
                            ))}
                        </ContentContainer>
                    </ContentWrapper>
                </Wrapper>
            </FilterProvider>
            </AlertProvider>
        )
    }
}

export default App;
